<template>
  <v-card flat class="modal-card">
    <v-card-title>
      <span class="headline">{{ formTitle }} Call/Text Blocking Number</span>
      <v-spacer></v-spacer>
      <v-btn text icon color="grey" @click="onClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-form ref="form" v-model="formValid" @submit.prevent="onSave">
      <v-card-text>
        <v-row class="ma-3">
          <v-col cols="12">
            <v-text-field
              autocomplete="off"
              hint="e.g. (555) 555-1212"
              v-mask="masks.phone"
              v-model="numberName"
              required
              :rules="[rules.required, rules.phone]"
              label="Phone Number"
              placeholder="Phone Number"
              @input="updateConfig('name', $event)"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="my-4"
          color="primary"
          @click="onSave"
          :disabled="!(listItem ? listItem.isDirty : false)"
          >Save</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import ListItem from "../../../models/ListItem";
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import { MASKS } from "../../../helpers/Masks";
import { PhoneNumberCleanFormat } from "../../../helpers/phoneNumberFormatter";
import { mask } from "vue-the-mask";

export default {
  name: "CallBlockNumberModal",
  components: {},
  directives: {
    mask
  },
  props: {
    PhoneNumberId: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      formValid: true,
      editedItem: new ListItem(),

      trackingNumberConfig: {},

      numberName: "",
      phoneNumber: null,
      isLocal: false,
      areaCode: "",
      phoneNumbers: [],
      listItem: {},

      masks: MASKS,
      rules: VALIDATION_RULES
    };
  },
  computed: {
    formTitle() {
      return this.PhoneNumberId === -1 ? "Add" : "Edit";
    },
    blockingPhoneTypeId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("code", value => ["phone_blocklist"].includes(value))
        .first();
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    },
    blockedPhones() {
      const listType = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("code", value => ["phone_blocklist"].includes(value))
        .first();
      return listType;
    }
  },
  created() {
    if (
      this.PhoneNumberId > 0 &&
      this.blockedPhones.items &&
      this.blockedPhones.items.length > 0
    ) {
      const vueThis = this;
      const currentItem = this.blockedPhones.items.filter(phone => {
        return phone.id == vueThis.PhoneNumberId;
      })[0];
      this.listItem = Object.assign({}, currentItem);
      this.numberName = currentItem.name;
    } else {
      this.listItem = {
        listTypeId: this.blockingPhoneTypeId,
        meta: {
          value: null
        }
      };
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        const editedItem = this.listItem;
        if (this.PhoneNumberId > 0) {
          this.$store.dispatch(
            "entities/listItems/updateListItem",
            editedItem
          );
        } else {
          this.$store.dispatch(
            "entities/listItems/createListItem",
            editedItem
          );
        }
        this.onClose();
      }
    },
    updateConfig(field, value) {
      if (!this.listItem.meta) {
        this.listItem.meta = {};
      }
      this.listItem.isDirty = true;
      if (field == "name") {
        this.listItem.name = value;
        this.listItem.meta = {
          value: PhoneNumberCleanFormat(value)
        }
      }
    },
    onClose() {
      this.$parent.$parent.$parent.$parent.showDialogContainer = false;
    }
  }
};
</script>

<style scoped lang="stylus"></style>
